module.exports = __webpack_public_path__ + "img/icon-keystore-file.956cbf72.svg";